'use strict'

/**
 * @module article
 * @requires module:slider
 * @requires module:stickyNav
 */
import stickyNav from '../components/stickyNav'
import history from '../components/history'

const CLASS_ACTIV = 'activ'

const ATTRIBUTE_CONTACT = 'data-contact'

export default {
  /**
   * Initialise article
   *
   * @method init
   */
  init() {
    this.bind()
    /**
     * @see module:stickyNav#init
     */
    stickyNav.init()
    history.init()
  },

  /**
   * bind events
   *
   * @method bind
   */
  bind() {
    if (document.getElementsByClassName('js-contact').length) {
      document.getElementsByClassName('js-contact').item(0).bindEvent('click', this.displayContact)
    }
  },

  /**
   * display phone number & update href
   *
   * @method displayContact
   */
  displayContact(e) {
    const current = e.currentTarget
    if (current.classList.contains(CLASS_ACTIV)) {
      return
    }
    e.preventDefault()
    current.classList.add(CLASS_ACTIV)
    current.href = `tel:${current.getAttribute(ATTRIBUTE_CONTACT)}`
  }
}



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/modules/article.js